import { render, staticRenderFns } from "./snatch-selection.vue?vue&type=template&id=5b1ad616&scoped=true&"
import script from "./snatch-selection.vue?vue&type=script&lang=js&"
export * from "./snatch-selection.vue?vue&type=script&lang=js&"
import style0 from "./snatch-selection.vue?vue&type=style&index=0&id=5b1ad616&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1ad616",
  null
  
)

export default component.exports